export default {"src":"/_next/static/media/sticker-6.71127f76.svg","height":304,"width":305,"blurWidth":0,"blurHeight":0};